<script>
export default {
    name: "p-select",
    props: ["value", "name", "label", "options", "type", "error"],

    data() {
        return {
            filterIsActive: false
        };
    },
    methods: {
        updateData() {
            this.$emit("input", this.$refs.selecttPicker.value);
        }
    },
    computed: {
        inputListeners: function() {
            var vm = this;
            return Object.assign({}, this.$listeners, {
                input: function(event) {
                    vm.$emit("input", event.target.value);
                }
            });
        }
    },
    created: function() {}
};
</script>
<template>
    <div class="p-select field" :class="{active: filterIsActive}">
        <label for="528" class="label">
            <span>{{label}}:</span>
        </label>
        <div class="inner" :class="{ error: error }">
            <select v-if="typeof type == 'undefined'" class="select" :name="name" :value="value" ref="selecttPicker" v-on="inputListeners" @focus="filterIsActive = true" @blur="filterIsActive = false">
                <option value="1">value 1</option>
                <option value="2">value 2</option>
                <option value="3">value 3</option>
            </select>

            <!-- Type Gender -->
            <select v-if="type='gender'" class="select" :name="name" :value="value" :data-name="label" ref="selecttPicker" v-on="inputListeners" required @focus="filterIsActive = true" @blur="filterIsActive = false">
            <option :value="null">Selecione</option>
                <option value="M">Masculino</option>
                <option value="F">Feminino</option>
            </select>
        </div>
        <span class="error-status">{{error}}</span>
    </div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/p-select.vue